/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
import * as XLSX from "xlsx";
import initCapitalize from "./initCapitalize";
import { getCurrentDateForReportGeneration, formatUSADateService } from "./date";

const JSONToExcel = async (JSONdata: any, fileName: string) => {
	try {
		/* generate worksheet and workbook */
		const { user, reportFieldDetails, response, billing_month, billing_year, api_route } = JSONdata;
		// console.log("JSON Data", typeof JSONdata.reportFieldDetails.date);

		const worksheet = XLSX.utils.json_to_sheet(response);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "DataSheet");

		/* fix headers */
		const excelHeaders: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
		// console.log("excelHeaders", excelHeaders);
		const _excelHeaders: string[] = [];

		excelHeaders.forEach((header: string) => {
			const _header =
				header === "employee_SSN"
					? "Employee SSN"
					: header === "Employee Ssn"
					? "Employee SSN"
					: header === "Member Ssn"
					? "Member SSN"
					: header.includes("_")
					? initCapitalize(header.replaceAll("_", " ")).trim()
					: header === "SSN"
					? header.trim()
					: initCapitalize(header).trim();
			_excelHeaders.push(_header as string);
		});

		// console.log(billing_month, api_route, "=====>New Headers", reportFieldDetails);

		XLSX.utils.sheet_add_aoa(worksheet, [_excelHeaders], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["This Report is Generated by: "]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Role: ", initCapitalize(user?.role)]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Name: ", user?.name]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Date: ", getCurrentDateForReportGeneration()]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Filter used to run this report: "]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Group Number: ", reportFieldDetails?.group_number]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		if (api_route === "/veb-billing") {
			XLSX.utils.sheet_add_aoa(worksheet, [["Month of this report: "]], { origin: -1 });

			XLSX.utils.sheet_add_aoa(worksheet, [["Month Name: ", billing_month]], { origin: -1 });
		}
		if (reportFieldDetails?.base_plan_name !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Base Plan Name: ", reportFieldDetails?.base_plan_name]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.with_dependent !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["With Dependent: ", reportFieldDetails?.with_dependent]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.plan_code !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Plan Code: ", reportFieldDetails?.plan_code]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.plan_name !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Plan Name: ", reportFieldDetails?.plan_name]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.type !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Benefit Report Type: ", reportFieldDetails?.type]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.start_date !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Start Date: ", reportFieldDetails?.start_date]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.end_date !== undefined) {
			const endDate = reportFieldDetails?.end_date === "" ? "null" : reportFieldDetails?.end_date;
			XLSX.utils.sheet_add_aoa(worksheet, [["End Date: ", endDate]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.location_number !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Location Number: ", reportFieldDetails?.location_number]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.date !== undefined) {
			const Date = reportFieldDetails?.date === "" ? "null" : formatUSADateService(reportFieldDetails?.date);
			XLSX.utils.sheet_add_aoa(worksheet, [["Date: ", Date]], {
				origin: -1
			});
		}

		/* create an XLSX file and try to save to Presidents.xlsx */
		// console.log("Excel Filename: ", fileName);
		XLSX.writeFile(workbook, `${fileName}.xlsx`, { compression: true });
	} catch (error: any) {
		throw error;
	}
};


export const JSONToExcelWithTerminated = async (JSONdata: any, fileName: string) => {
	try {
		/* generate worksheet and workbook */
		const { user, reportFieldDetails, response, billing_month, billing_year, api_route, terminated } = JSONdata;
		// console.log("JSON Data", typeof JSONdata.reportFieldDetails.date);

		const worksheet = XLSX.utils.json_to_sheet(response);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "DataSheet");

		/* fix headers */
		const excelHeaders: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
		// console.log("excelHeaders", excelHeaders);
		const _excelHeaders: string[] = [];

		excelHeaders.forEach((header: string) => {
			const _header =
				header === "employee_SSN"
					? "Employee SSN"
					: header === "Employee Ssn"
					? "Employee SSN"
					: header === "Member Ssn"
					? "Member SSN"
					: header.includes("_")
					? initCapitalize(header.replaceAll("_", " ")).trim()
					: header === "SSN"
					? header.trim()
					: initCapitalize(header).trim();
			_excelHeaders.push(_header as string);
		});

		// console.log(billing_month, api_route, "=====>New Headers", reportFieldDetails);

		XLSX.utils.sheet_add_aoa(worksheet, [_excelHeaders], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["This Report is Generated by: "]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Role: ", initCapitalize(user?.role)]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Name: ", user?.name]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Date: ", getCurrentDateForReportGeneration()]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Filter used to run this report: "]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Group Number: ", reportFieldDetails?.group_number]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		if (api_route === "/veb-billing") {
			XLSX.utils.sheet_add_aoa(worksheet, [["Month of this report: "]], { origin: -1 });

			XLSX.utils.sheet_add_aoa(worksheet, [["Month Name: ", billing_month]], { origin: -1 });
		}
		if (reportFieldDetails?.base_plan_name !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Base Plan Name: ", reportFieldDetails?.base_plan_name]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.with_dependent !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["With Dependent: ", reportFieldDetails?.with_dependent]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.plan_code !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Plan Code: ", reportFieldDetails?.plan_code]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.plan_name !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Plan Name: ", reportFieldDetails?.plan_name]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.type !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Benefit Report Type: ", reportFieldDetails?.type]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.start_date !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Start Date: ", reportFieldDetails?.start_date]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.end_date !== undefined) {
			const endDate = reportFieldDetails?.end_date === "" ? "null" : reportFieldDetails?.end_date;
			XLSX.utils.sheet_add_aoa(worksheet, [["End Date: ", endDate]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.location_number !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Location Number: ", reportFieldDetails?.location_number]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.date !== undefined) {
			const Date = reportFieldDetails?.date === "" ? "null" : formatUSADateService(reportFieldDetails?.date);
			XLSX.utils.sheet_add_aoa(worksheet, [["Date: ", Date]], {
				origin: -1
			});
		}

		/* ---- Sheet 2: Terminated employees ---- */
		const terminatedRows =
			terminated && terminated.length > 0 ? terminated : [{ Note: "No terminated employees" }];

		const terminatedSheet = XLSX.utils.json_to_sheet(terminatedRows);

		if (terminated && terminated.length > 0) {
			const terminatedHeaders: any = XLSX.utils.sheet_to_json(terminatedSheet, { header: 1 })[0];
			const _terminatedHeaders: string[] = [];

			terminatedHeaders.forEach((header: string) => {
				const _header =
					header === "employee_SSN"
						? "Employee SSN"
						: header === "Employee Ssn"
						? "Employee SSN"
						: header === "Member Ssn"
						? "Member SSN"
						: header.includes("_")
						? initCapitalize(header.replaceAll("_", " ")).trim()
						: header === "SSN"
						? header.trim()
						: initCapitalize(header).trim();
				_terminatedHeaders.push(_header as string);
			});

			XLSX.utils.sheet_add_aoa(terminatedSheet, [_terminatedHeaders], { origin: "A1" });
		}

		XLSX.utils.book_append_sheet(workbook, terminatedSheet, "Terminated");

		/* create an XLSX file and try to save to Presidents.xlsx */
		// console.log("Excel Filename: ", fileName);
		XLSX.writeFile(workbook, `${fileName}.xlsx`, { compression: true });
	} catch (error: any) {
		throw error;
	}
};

export const BulkUploadJSONToExcel = async (JSONdata: any, fileName: string) => {
	try {
		/* generate worksheet and workbook */
		// const { user, reportFieldDetails, response } = JSONdata;
		// console.log("JSON Data", typeof JSONdata.reportFieldDetails.date);

		const worksheet = XLSX.utils.json_to_sheet(JSONdata);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "DataSheet");

		/* fix headers */
		const excelHeaders: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
		// console.log("excelHeaders", excelHeaders);
		const _excelHeaders: string[] = [];

		// console.log("New Headers", reportFieldDetails);

		/* create an XLSX file and try to save to Presidents.xlsx */
		// console.log("Excel Filename: ", fileName);
		XLSX.writeFile(workbook, `${fileName}.xlsx`, { compression: true });
	} catch (error: any) {
		throw error;
	}
};

export const AOAtoExcel = async (JSONdata: any, fileName: string) => {
	try {
		/* generate worksheet and workbook */
		// console.log("JSON Data", JSONdata);
		const { user, reportFieldDetails, response } = JSONdata;
		const worksheet = XLSX.utils.aoa_to_sheet(response);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "DataSheet");

		/* fix headers */
		const excelHeaders: any = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
		// console.log("excelHeaders", excelHeaders);
		const _excelHeaders: string[] = [];

		excelHeaders.forEach((header: string) => {
			const _header =
				header === "employee_SSN"
					? "Employee SSN"
					: header === "Employee Ssn"
					? "Employee SSN"
					: header.includes("_")
					? initCapitalize(header.replaceAll("_", " ")).trim()
					: header === "SSN"
					? header.trim()
					: initCapitalize(header).trim();
			_excelHeaders.push(_header as string);
		});

		// console.log("New Headers", reportFieldDetails);

		XLSX.utils.sheet_add_aoa(worksheet, [_excelHeaders], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["This Report is Generated by: "]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Role: ", initCapitalize(user?.role)]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Name: ", user?.name]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Date: ", getCurrentDateForReportGeneration()]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Payload for this Report Generation: "]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Group Number: ", reportFieldDetails?.group_number]], { origin: -1 });
		if (reportFieldDetails?.with_dependent !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["With Dependent: ", reportFieldDetails?.with_dependent]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.plan_code !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Plan Code: ", reportFieldDetails?.plan_code]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.type !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Benefit Report Type: ", reportFieldDetails?.type]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.start_date !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Start Date: ", reportFieldDetails?.start_date]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.end_date !== undefined) {
			const endDate = reportFieldDetails?.end_date === "" ? "null" : reportFieldDetails?.end_date;
			XLSX.utils.sheet_add_aoa(worksheet, [["End Date: ", endDate]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.location_number !== undefined) {
			XLSX.utils.sheet_add_aoa(worksheet, [["Location Number: ", reportFieldDetails?.location_number]], {
				origin: -1
			});
		}
		if (reportFieldDetails?.date !== undefined) {
			const Date = reportFieldDetails?.date === "" ? "null" : reportFieldDetails?.date;
			XLSX.utils.sheet_add_aoa(worksheet, [["Date: ", Date]], {
				origin: -1
			});
		}

		/* create an XLSX file and try to save to Presidents.xlsx */
		// console.log("Excel Filename: ", fileName);
		XLSX.writeFile(workbook, `${fileName}.xlsx`, { compression: true });
	} catch (error: any) {
		throw error;
	}
};

export default JSONToExcel;
